import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import ErrorPage from "@/presentation/components/error-page/ErrorPage.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'NotFound',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ErrorPage, {
                code: "404",
                "title-key": "errorPage.notFound.title",
                "description-key": "errorPage.notFound.description"
            }));
        };
    }
});
